module.exports = __webpack_public_path__ + "img/dsci0136.aa93d688.jpg";